import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-management-services',
  templateUrl: './project-management-services.component.html'
})
export class ProjectManagementServicesComponent implements OnInit {

  scrollTimer: any;

  constructor() { }

  ngOnInit() {
  }

  startScroll(speed) {
    //console.log("mouse down:" + speed);

    this.scrollTimer = setInterval(() => {
      $("#servicesButtons").scrollLeft($("#servicesButtons").scrollLeft() + speed);
    }, 10);

  }

  stopScroll() {
    //console.log("mouse up -" + this.scrollTimer);
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
    }
  }

  toggleActive(e) {
    //console.log(e);
    $(".navButton").removeClass("active");
    e.srcElement.className = "navButton active";
  }

}
